var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersservice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "47px",
    viewBox: "0 0 69 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4860DC07-C387-4AAD-8199-ABB09F57A616") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products-(1)",
    transform: "translate(-96.000000, -825.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(82.000000, 827.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(16.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9611834,7.00592572 C39.9577678,10.8709971 36.8012903,14.001825 32.9102467,13.9995654 C29.0192034,13.9973031 25.8664151,10.8628102 25.867552,6.9977371 C25.8686895,3.13266386 29.023322,0 32.914366,0 C34.7841183,0.000814414499 36.5769643,0.73939416 37.8984987,2.05326012 C39.2200336,3.36712606 39.9620036,5.14865294 39.9611834,7.00592572 Z",
    id: "Vector-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1868411,24.3226518 L25.6541326,24.3226518 C20.5768013,24.4810932 16.5434192,28.6153952 16.5434192,33.6613264 C16.5434192,38.7072569 20.5768013,42.84156 25.6541326,43.0000009 L40.1868411,43.0000009 C45.264172,42.84156 49.2975546,38.7072569 49.2975546,33.6613264 C49.2975546,28.6153952 45.264172,24.4810932 40.1868411,24.3226518 L40.1868411,24.3226518 Z",
    id: "Vector-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7838458,12.3595137 C57.7821373,15.3157682 55.368434,17.7110691 52.3923147,17.7099395 C49.4161953,17.7088089 47.0043368,15.3116736 47.0049055,12.3554185 C47.0054744,9.3991635 49.4182552,7.00294413 52.3943746,7.00294413 C53.8242872,7.00294413 55.1955887,7.56739311 56.206399,8.57203311 C57.2172098,9.57667306 57.784665,10.9391454 57.7838458,12.3595137 L57.7838458,12.3595137 Z",
    id: "Vector-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21626646,12.3594414 C7.21626646,15.3160964 9.62921449,17.7129391 12.6057366,17.7129391 C15.5822586,17.7129391 17.9952068,15.3160964 17.9952068,12.3594414 C17.9952068,9.40278631 15.5822586,7.00594369 12.6057366,7.00594369 C9.62921449,7.00594369 7.21626646,9.40278631 7.21626646,12.3594414 L7.21626646,12.3594414 Z",
    id: "Vector-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.915644,26.3804549 L57.9569738,26.3804549 C61.8701299,26.461064 65,29.6351857 65,33.523059 C65,37.4109322 61.8701299,40.5850541 57.9569738,40.6656631 L53.915644,40.6656631 M11.084356,26.3804549 L7.04302639,26.3804549 C3.12987009,26.461064 0,29.6351857 0,33.523059 C0,37.4109322 3.12987009,40.5850541 7.04302639,40.6656631 L11.084356,40.6656631",
    id: "Vector-27"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersservice);
export default __webpack_public_path__ + "static/media/Users service.f95e1716714dc5a33fac948316226fed.svg";
export { ForwardRef as ReactComponent };